import { render, staticRenderFns } from "./daily-cargo-general.vue?vue&type=template&id=bc5cf6e8"
import script from "./daily-cargo-general.vue?vue&type=script&lang=js"
export * from "./daily-cargo-general.vue?vue&type=script&lang=js"
import style0 from "./daily-cargo-general.vue?vue&type=style&index=0&id=bc5cf6e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports